import { h } from "preact";

import IconProps from "./IconProps";

const DEFAULT_COLOR = "var(--label-primary)";

function IconFlowConnectorEndArrow({
    class: cssClass,
    color
}: IconProps) {
    const fill = color ?? `var(--icon-color, ${DEFAULT_COLOR})`;

    return (
        <svg class={cssClass} width="18" height="18" viewBox="0 0 18 18" fill="none" xmlns="http://www.w3.org/2000/svg">
            <path fill={fill} d="M9.293 4.05a1 1 0 0 1 1.414 0l4.243 4.243a.995.995 0 0 1 .29.779.997.997 0 0 1-.29.635l-4.243 4.243a1 1 0 1 1-1.414-1.414L11.829 10H4a1 1 0 1 1 0-2h7.828L9.293 5.464a1 1 0 0 1 0-1.414z"/>
        </svg>
    );
}

export default IconFlowConnectorEndArrow;
